<div class="content-main form-field-density-4" >    
    <div class="content">
        <mat-accordion multi>
            <mat-expansion-panel *ngFor="let item of uniqueArray">
                <mat-expansion-panel-header>
                    {{item.group}}
                </mat-expansion-panel-header>
                <mat-grid-list cols="4" rowHeight="150px">
                    <mat-grid-tile
                        *ngFor="let data of attribs|arrayFilter:'grupId':item.grupId:false:false">
                        <div class="data-card">
                            <ng-container  [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:data}" ></ng-container>            
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>

<ng-template #main let-item let-type="type" >
    <mat-card  appearance="outlined"  [ngClass]="{'cardnon':!isRequired(item), 'cardred':isRequired(item)}" >
        <mat-card-header>
            <mat-icon class="close" (click)="deleteItem(item)" *ngIf="!isRequired(item)">close</mat-icon>
            <mat-card-title [matTooltip]="item.name">
            {{item.name}}
            <mat-icon class="warn" matTooltip="Esse atributo é de variação, não preencher se o produto tiver variação." *ngIf="isVariant(item)">warning</mat-icon>
            </mat-card-title>
            <mat-card-subtitle >{{item.nameId}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="card-content">
            <mat-form-field appearance="outline"  *ngIf="item.type=='Texto'" class="full" >
                <mat-label>{{item.name}}</mat-label>
                <input matInput type="text"  [(ngModel)]="item.datavalue" [required]="isRequired(item)" [CustomValidatorDirective]="attribValidator">
                <button   matSuffix mat-icon-button aria-label="Clear" (click)="openDataOption(item)" matTooltip="Buscar Informação">
                    <mat-icon>reply</mat-icon>
                </button>                                                                                       
                <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            
            <mat-form-field appearance="outline"  *ngIf="item.type=='Texto Grande'" class="full" >
                <mat-label>{{item.name}}</mat-label>
                <textarea matInput type="text"  [(ngModel)]="item.datavalue" [required]="isRequired(item)" [CustomValidatorDirective]="attribValidator"></textarea>
                <button   matSuffix mat-icon-button aria-label="Clear" (click)="openDataOption(item)" matTooltip="Buscar Informação">
                    <mat-icon>reply</mat-icon>
                </button>                                                                                       
                <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            

            <mat-form-field appearance="outline" *ngIf="item.dadosValores!= null && item.dadosValores.length > 0 && item.type=='Radio'" class="full">
                <mat-label>{{item.name}}</mat-label>
                <mat-select #select  [(value)]="item.datavalue" [required]="isRequired(item)"   [CustomValidatorDirective]="attribValidator">
                    <mat-option></mat-option>
                    <mat-option [value]="option.value" *ngFor="let option of item.dadosValores">{{ option.descriptionValue }}</mat-option>
                </mat-select>
            </mat-form-field>        
        </mat-card-content>
    </mat-card>
</ng-template>